<mat-card class="filter settingHeader">
  <div class="name">
    Manage OCR Template Category
  </div>

  <div class="quickAction">    

    <mat-form-field appearance="fill">
      <mat-label>Select Category</mat-label>
      <mat-select (selectionChange)="OnChnageCategory($event)" value="My Template">
        <mat-option value="My Template">My Template</mat-option>
        <mat-option value="Organization">Organization Template</mat-option>           
      </mat-select>
    </mat-form-field>
      <!-- <mat-form-field class="example-form-field" appearence="fill">
        <mat-label>Search Category</mat-label>
        <input matInput type="text"  readonly  [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
        <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon>close</mat-icon>
        </button>
        <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field> -->
        
        <!-- <div class="">      
          <button mat-flat-button color="primary" (click)="openDialogAdd(addmyDialog)"> Add Category </button>   
       </div> -->
     
  </div>
</mat-card>

<div class="documents">

    <mat-card class="example-list rowholder">
      <div class="fieldRow head">
        <span class="moveicon"></span>       
        <span class="fieldName">Category Name</span>
        <span class="requried">Active/Inactive</span>
        <span class="editField">Edit</span>
        <span class="delete">Delete</span>
      </div>
      <div class="example-box fieldRow" *ngFor="let type of categoryList">
        <span class="moveicon"></span>        
         <span class="fieldName">{{type.ocrTemplateCategoryName}}</span>  
        <span class="requried">
          <mat-slide-toggle color="primary" [checked]="type.isActive" (change)="UpdateStatusToggle(type,$event)">
          </mat-slide-toggle>
        </span> 
  
        <span class="editField">
          <button mat-icon-button class="editbtn" (click)="openDialogUpdateType(myDialog,type)">
            <mat-icon>edit</mat-icon>
          </button>
        </span>
  
        <span class="delete">
          <button mat-icon-button class="trash" (click)="DeleteCategory(type)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </span>
      </div>   
      
      <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>
      
    </mat-card>

</div>


<!-- <ng-template #addmyDialog>
  <form  [formGroup]="formDialog">
  <h2 mat-dialog-title>
      Add Category Name
      <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
      <mat-label>Category Name</mat-label>
      <input matInput maxlength="30" [required]="true"  placeholder="Edit category name"  formControlName="categoryName"/>
      <mat-error
      *ngIf="formDialog.get('categoryName').invalid &&
        (formDialog.get('categoryName').dirty ||
        formDialog.get('categoryName').touched)">
      <span>This field is mandatory.</span>
    </mat-error>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" 
  [disabled]="formDialog.invalid || !formDialog.dirty"   
  (click)="AddCategoryNameDetails(formDialog.value)">
    Save
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
</mat-dialog-actions>
<app-loader></app-loader>
</form>
</ng-template> -->

<ng-template #myDialog>
  <form  [formGroup]="formDialog">
  <h2 mat-dialog-title>
      Edit Category Name
      <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
      <mat-label>Category Name</mat-label>
      <input matInput maxlength="30" [required]="true"  placeholder="Edit category name"  formControlName="categoryName"/>
      <mat-error
      *ngIf="formDialog.get('categoryName').invalid &&
        (formDialog.get('categoryName').dirty ||
        formDialog.get('categoryName').touched)">
      <span>This field is mandatory.</span>
    </mat-error>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" 
  [disabled]="formDialog.invalid || !formDialog.dirty"   
  (click)="UpdateCategoryNameDetails(formDialog.value)">
    Update
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
</mat-dialog-actions>
<app-loader></app-loader>
</form>
</ng-template>

